import { IPhase, PhaseModel, PhaseStatus, PhaseType } from '../types';
import { PhaseEventBus } from './PhaseEventBus';

export abstract class BasePhaseModel<TData = unknown> implements PhaseModel<TData> {
  protected eventBus = new PhaseEventBus<TData>();

  constructor(public phase: IPhase<TData>) {}

  get type(): PhaseType {
    return this.phase.type;
  }

  on = (name: Parameters<PhaseModel<TData>['on']>[0], handler: Parameters<PhaseModel<TData>['on']>[1]) =>
    this.eventBus.subscribe(name, handler);

  sync(phase: IPhase<TData>): void {
    this.phase = phase;
  }

  async load(): Promise<IPhase<TData>> {
    this.eventBus.emit('load', this.phase.data as TData);
    return this.phase;
  }

  async save(update?: Partial<IPhase<TData>>): Promise<IPhase<TData>> {
    this.phase = { ...this.phase, ...update };
    this.eventBus.emit('save', this.phase.data as TData);
    return this.phase;
  }

  updateData(data: TData): IPhase<TData> {
    this.phase = { ...this.phase, data };
    this.eventBus.emit('data:update', data);
    return this.phase;
  }

  setStatus(status: PhaseStatus): IPhase<TData> {
    this.phase = { ...this.phase, status };
    this.eventBus.emit('status', this.phase.data as TData);
    return this.phase;
  }

  activate(): IPhase<TData> {
    this.phase = { ...this.phase, isActive: true, status: 'active' };
    this.eventBus.emit('activate', this.phase.data as TData);
    return this.phase;
  }

  deactivate(): IPhase<TData> {
    const status = this.phase.status === 'active' ? 'open' : this.phase.status;
    this.phase = { ...this.phase, isActive: false, status };
    this.eventBus.emit('deactivate', this.phase.data as TData);
    return this.phase;
  }
}
